export default class AuthenticationError extends Error {
  constructor (message, renewUrl) {
    super(message)

    this.renewUrl = renewUrl
  }
}
